// import Swiper JS
import Swiper from 'swiper';
import YTPlayer from 'yt-player';

// import Swiper styles
import 'swiper/swiper-bundle.css';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Pagination]);

import '../styles/index.scss';

if (process.env.NODE_ENV === 'development') {
  require('../index.html');
}

  // init Swiper:
  const swiper = new Swiper('.samuel-bich-slider', {
    // Optional parameters
    // direction: 'vertical',
    loop: true,

    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    // },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });

//   const player = new YTPlayer('#player', {
//     autoplay: true,
//     controls: false,
//     modestBranding: false,
//     annotations: false,
//     related: false,
//     autohide: true,
//     showinfo: false,
//   });

// player.load('D-MY3N_BllQ', true);
// player.play();
// player.setVolume(100);

// player.on('playing', () => {
//   console.log(player.getDuration()); // => 351.521
// });
